import React, { useState, useEffect } from "react";
import {
  FaStar,
  FaSun,
  FaHeart,
  FaChild,
  FaGem,
  FaUsers,
} from "react-icons/fa";
import "../styles/Booking.css";

const Booking = () => {
  const bookingLinks = [
    {
      name: "Natalna karta",
      url: "https://tidycal.com/astrologija-vortex/natalna-karta",
      icon: FaStar,
      description: "Odkrijte svoj življenjski potencial",
    },
    {
      name: "Solarni horoskop",
      url: "https://tidycal.com/astrologija-vortex/solarni-horoskop",
      icon: FaSun,
      description: "Napoved za prihodnje leto",
    },
    {
      name: "Sinastrija",
      url: "https://tidycal.com/astrologija-vortex/sinastrija",
      icon: FaHeart,
      description: "Analiza odnosa in kompatibilnosti",
    },
    {
      name: "Karmična natalna karta",
      url: "https://tidycal.com/astrologija-vortex/karmicna-natalna-karta",
      icon: FaGem,
      description: "Globinski vpogled v karmične vzorce",
    },
    {
      name: "Karmična sinastrija",
      url: "https://tidycal.com/astrologija-vortex/karmicna-sinastrija",
      icon: FaUsers,
      description: "Karmična povezava v odnosih",
    },
    {
      name: "Natalna karta mojega otroka",
      url: "https://tidycal.com/astrologija-vortex/natalna-karta-mojega-otroka",
      icon: FaChild,
      description: "Razumite edinstveno naravo vašega otroka",
    },
  ];

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const FIELD_LIMITS = { name: 100, email: 254, phone: 40, message: 2000 };

  const getFormspreeEndpoint = () => {
    const raw = (process.env.REACT_APP_FORMSPREE_ENDPOINT || "").trim();
    if (!raw) return "";
    try {
      const url = new URL(raw);
      if (url.protocol !== "https:") return "";
      if (
        url.hostname !== "formspree.io" &&
        !url.hostname.endsWith(".formspree.io")
      ) {
        return "";
      }
      return url.toString();
    } catch {
      return "";
    }
  };

  const CONTACT_EMAIL = (
    process.env.REACT_APP_CONTACT_EMAIL || "boriskeleman@gmail.com"
  ).trim();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const max = FIELD_LIMITS[name];
    setForm({
      ...form,
      [name]: max ? value.slice(0, max) : value,
    });
  };

  const FORMSPREE_ENDPOINT = getFormspreeEndpoint();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSending(true);

    const payload = {
      name: form.name.trim().slice(0, FIELD_LIMITS.name),
      email: form.email.trim().slice(0, FIELD_LIMITS.email),
      phone: form.phone.trim().slice(0, FIELD_LIMITS.phone),
      message: form.message.trim().slice(0, FIELD_LIMITS.message),
    };

    if (!payload.name || !payload.email || !payload.message) {
      setError("Izpolnite obvezna polja.");
      setSending(false);
      return;
    }

    // Store locally for admin preview (optional) — cap size to limit PII retention
    try {
      const inbox = JSON.parse(localStorage.getItem("vortex_messages") || "[]");
      inbox.unshift({ ...payload, date: new Date().toISOString() });
      localStorage.setItem(
        "vortex_messages",
        JSON.stringify(inbox.slice(0, 20))
      );
    } catch (err) {
      // Non-critical
    }

    // Priority 1: Formspree (FREE - up to 50 submissions/month)
    if (FORMSPREE_ENDPOINT) {
      try {
        const res = await fetch(FORMSPREE_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });
        if (res.ok) {
          setSent(true);
          setForm({ name: "", email: "", phone: "", message: "" });
          setSending(false);
          return;
        }
        setError("Napaka pri pošiljanju. Poskusite ponovno ali pokličite.");
        setSending(false);
        return;
      } catch (err) {
        setError("Napaka pri pošiljanju. Poskusite ponovno ali pokličite.");
        setSending(false);
        return;
      }
    }

    // Fallback: open mail client if Formspree not configured
    const subject = encodeURIComponent(`Sporočilo od ${payload.name}`);
    const body = encodeURIComponent(
      `Ime: ${payload.name}\nTelefon: ${payload.phone || "-"}\nEmail: ${
        payload.email
      }\n\nSporočilo:\n${payload.message}`
    );
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;

    setSent(true);
    setForm({ name: "", email: "", phone: "", message: "" });
    setSending(false);
  };

  useEffect(() => {
    document.title = "Rezervacije — Astrologija v Vortexu";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Rezervirajte termin za natalno karto, sinastrijo ali karmične analize. Enostaven sistem rezervacij in možnost neposrednega stika."
      );
  }, []);

  return (
    <div className="booking-page">
      <div className="booking-hero">
        <h2 className="page-title">Rezervacije</h2>
        <p className="intro-text">
          Izberite željeno storitev in rezervirajte svoj termin. Po kliku na
          gumb se odpre varno rezervacijsko okno, kjer lahko izberete prosti
          termin.
        </p>
      </div>

      <div className="booking-grid">
        <div className="booking-services">
          <h3 style={{ marginBottom: "1.5rem", color: "#004c6d" }}>
            Razpoložljive storitve
          </h3>
          <div className="services-cards">
            {bookingLinks.map((item) => {
              const IconComponent = item.icon;
              return (
                <div key={item.url} className="service-booking-card">
                  <div className="service-card-icon">
                    <IconComponent size={32} />
                  </div>
                  <h4 className="service-card-title">{item.name}</h4>
                  <p className="service-card-description">{item.description}</p>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button primary booking-card-button"
                  >
                    Rezerviraj →
                  </a>
                </div>
              );
            })}
          </div>

          <div
            style={{
              marginTop: "2rem",
              padding: "1.5rem",
              backgroundColor: "rgba(0, 168, 198, 0.05)",
              borderRadius: "12px",
              border: "1px solid rgba(0, 168, 198, 0.2)",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "0.9rem",
                color: "#004c6d",
                lineHeight: "1.6",
              }}
            >
              <strong>💡 Kako poteka rezervacija?</strong>
              <br />
              Izberite storitev in kliknite gumb. V novem oknu izberete želeni
              datum in uro, izpolnite svoje podatke in potrdite rezervacijo.
              Takoj prejmete potrdilo na e-pošto.
            </p>
          </div>
        </div>

        <aside className="booking-aside">
          <div className="contact-card card">
            <h3>Pošlji sporočilo</h3>
            <p>
              Izpolnite obrazec in sporočilo bo poslano na našo e-pošto.
              Odgovorimo v najkrajšem možnem času.
            </p>
            <form
              onSubmit={handleSubmit}
              className="contact-form"
              aria-live="polite"
            >
              <label htmlFor="contact-name">
                Ime *
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Vaše ime in priimek"
                  required
                  aria-required="true"
                  maxLength={FIELD_LIMITS.name}
                  autoComplete="name"
                />
              </label>
              <label htmlFor="contact-email">
                Email *
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="vas.email@example.com"
                  required
                  aria-required="true"
                  maxLength={FIELD_LIMITS.email}
                  autoComplete="email"
                />
              </label>
              <label htmlFor="contact-phone">
                Telefon
                <input
                  id="contact-phone"
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="040 123 456 (neobvezno)"
                  maxLength={FIELD_LIMITS.phone}
                  autoComplete="tel"
                />
              </label>
              <label htmlFor="contact-message">
                Sporočilo *
                <textarea
                  id="contact-message"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows={6}
                  placeholder="Opišite vašo težavo ali vprašanje..."
                  required
                  aria-required="true"
                  maxLength={FIELD_LIMITS.message}
                />
              </label>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <button
                  type="submit"
                  className="button primary"
                  disabled={sending}
                  style={{ position: "relative" }}
                >
                  {sending ? (
                    <>
                      <span style={{ opacity: 0 }}>Pošiljam…</span>
                      <span
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          style={{ animation: "spin 1s linear infinite" }}
                        >
                          <circle cx="12" cy="12" r="10" opacity="0.25" />
                          <path d="M12 2a10 10 0 0 1 10 10" opacity="0.75" />
                        </svg>
                        Pošiljam…
                      </span>
                    </>
                  ) : (
                    "Pošlji sporočilo"
                  )}
                </button>
                {sent && (
                  <div className="sent-note" role="status">
                    ✓ Hvala — sporočilo je poslano.
                  </div>
                )}
                {error && (
                  <div
                    className="error-note"
                    role="alert"
                    style={{ color: "#c00", fontSize: 14 }}
                  >
                    {error}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className="contact-phone">
            <strong>Pokličite nas:</strong>
            <div>
              <a href="tel:+386040942579" className="phone-link">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    fill="#004c6d"
                    d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24 11.36 11.36 0 0 0 3.56.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.56a1 1 0 0 1-.24 1.01l-2.21 2.22z"
                  />
                </svg>
                <span style={{ marginLeft: 8 }}>040 942 579</span>
              </a>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Booking;
